import { RouteRecordRaw } from "vue-router";
const routes: RouteRecordRaw[] = [
  {
    path: "coursePriceBox",
    name: "coursePriceBox",
    component: () => import("@/views/coursePriceBox/index.vue")
  }
];
export default routes;
